import { getPlayerStories } from '../queries/getPlayerStories';

const getPlayerStoryParams = (playerIds, env = 'prod') => {
    const variables = {
        playerIds
    };
    const query = encodeURIComponent(getPlayerStories);
    return {
        env,
        variables: encodeURIComponent(JSON.stringify(variables)),
        query
    };
};

export default getPlayerStoryParams;
